import { BaseApi } from '@/main/baseApi';
import { PARTNER } from '@/modules/kartoteka/constants';

import { DMS_MODULE, NAME } from './constants';

export const apiProvider = new BaseApi(DMS_MODULE, PARTNER, NAME);
